<div class="row">
  <div class="col text-right">
    <div>
      <span kendoTooltip position="left" [tooltipTemplate]="kInformationTemplatebp1" title="kInformationTemplatebp1" class="k-icon k-i-information k-i-info build_and_buy"></span>
    </div>
  </div>
</div>
<div *ngIf="configError.length>0" style="padding: 10px; border-radius: 5px; color: red;">
  {{configError}}
</div>
<div *ngIf="productModel?.erros?.length>0" style="padding:10px;border-radius:5px;">
  <div *ngFor="let msg of productModel?.erros" style="color:red;">
    {{
msg
    }} <br />
  </div>
</div>
<div class="product-config-container-row">
  <div class="product-config-container-col">
    <div class="form-group attr-width">
      <div>
        <strong>
          --General--
        </strong>
        <hr />
      </div>
      <div class="form-group" style="height:20px;"></div>
      <div class="form-group attr-width">
        <label for="productReference ">Product Reference</label>
        <input type="text"
               class="form-control"
               id="productReference"
               name="productReference"
               maxlength=16
               [disabled]="configCreationInProgres"
               [(ngModel)]="productModel.reference">
      </div>

      <div class="form-group attr-width">
        <label for="productQuantity">Quantity</label>
        <input type="text"
               class="form-control"
               id="productQuantity"
               name="productQuantity"
               [disabled]="configCreationInProgres"
               [(ngModel)]="productModel.quantity">

      </div>
      <div *ngFor="let attrs of productModel.productAttributes;let attrIndex=index">
        <app-test-attr-c [attrs]="attrs" [disabled]="configCreationInProgres"
                         (attrChange)="executeMacro(attrs)"></app-test-attr-c>
      </div>
      <hr />
      <ul *ngFor="let err of productErrors " class="error-list">
        <li style="color: red;">{{err.errorMessage}}</li>
      </ul>
    </div>
  </div>
  <div *ngIf="productModel?.resourceFrame?.frameName?.length>0" class="product-config-container-col">
    <div class="form-group attr-width">
      <div>
        <strong>
          --{{productModel.resourceFrame.frameName}}--
        </strong>
        <hr />
      </div>
      <!--<div class="form-group" style="height:20px;" *ngIf="productModel?.resourceFrame?.frameAdditionalText?.length>0">
        <div *ngIf="productModel?.resourceFrame?.frameAdditionalText?.length>0">
          <strong>{{productModel.resourceFrame.frameAdditionalText}}</strong>
        </div>
      </div>-->
      <div class="form-group" style="height:20px;">
        <div *ngIf="productModel?.resourceFrame?.frameConfig?.length>0 && isInAdmin">
          <span>{{productModel.resourceFrame.frameConfig}}</span>
        </div>
      </div>
      <div *ngFor="let attrs of productModel.resourceFrame.attributeFilters;let attrCIndex=index">
        <app-test-attr-c [attrs]="attrs" [disabled]="configCreationInProgres"
                         (attrChange)="executeMacro(attrs)"></app-test-attr-c>
      </div>
      <hr />
      <ul *ngFor="let err of resourceFrameErrors" class="error-list">
        <li style="color: red;">{{err.errorMessage}}</li>
      </ul>
    </div>
  </div>
  <div *ngFor="let nestFrame of productModel.nestedFrames;let i=index;" class="product-config-container-col">
    <div class="form-group attr-width">
      <div>
        <strong>
          --{{nestFrame.frameName}}--
        </strong>
        <hr />
      </div>
      <div class="form-group" style="height:20px;">
        <div *ngIf="nestFrame?.frameConfig?.length>0 && isInAdmin">
          <span>{{nestFrame.frameConfig}}</span>
        </div>
      </div>
      <!--<div class="form-group" style="height:20px;" *ngIf="productModel?.resourceFrame?.frameAdditionalText?.length>0">
      </div>-->
      <div *ngFor="let attrs of nestFrame.attributeFilters;let attrIndex=index">
        <app-test-attr-c [attrs]="attrs" [disabled]="configCreationInProgres"
                         (attrChange)="executeMacro(attrs)"></app-test-attr-c>
      </div>
      <div *ngIf="productModel.nestedFrames.length>1">
        <hr />
        Copy settings from
        <select #selectedFromIndex name="selectedFromIndex">
          <option value="-1"></option>
          <ng-container *ngFor="let f of  productModel.nestedFrames;let fIndex=index;">
            <ng-container *ngIf="fIndex!==i">
              <option value="{{fIndex}}">{{fIndex+1}}</option>
            </ng-container>
          </ng-container>
        </select>
        <button class="m-3 clearKendoButton btn btn-success"
                (click)="copySettings(i,selectedFromIndex?.value)"
                kendoButton>
          Copy
        </button>
      </div>
      <hr />
      <ul *ngFor="let err of nestedFrameErrors[i]">
        <li style="color: red;">{{err.errorMessage}}</li>
      </ul>
    </div>
  </div>

</div>
<div class="text-center">
  <button class="m-3 clearKendoButton btn btn-success"
          (click)="submitConfiguration(false)"
          [disabled]="configCreationInProgres"
          kendoButton>
    Continue<kendo-loader *ngIf="configCreationInProgres" style="color:blue"></kendo-loader>
  </button>
</div>

<section>
  <ng-template #kInformationTemplatebp1 let-kInformationTemplateAnchorbp1>
    <div lass="text-white-50 bg-dark" *ngIf="productModel.type !== 1">
      <ol>
        <li class="info">Please enter some general information so we can return a complete list of valid options for your item</li>
        <li>Select a matching door/frame to go with your selected A1 package </li>
        <li>If you do not want a matching door/frame, do not make a selection from that menu </li>
        <li>Click ‘Continue’ when you are ready to proceed to the next screen </li>
      </ol>
    </div>
    <div lass="text-white-50 bg-dark" *ngIf="productModel.type === 1">
      <ol>
        <li class="info">Please enter some general information so we can return a complete list of valid options for your item</li>
        <li>All menus on this screen require a selection</li>
        <li>Click ‘Continue’ when you are ready to proceed to the next screen</li>
      </ol>
    </div>
  </ng-template>
</section>
